import { isEmptyHtml } from './htmlUtils';

export const newLineStringsFromList = list => (
    list ? list.reduce(
        (prev, curr) => (prev ? `${prev}\r\n${curr}` : curr),
        '',
    ) : ''
);

export const commaStringsFromList = list => (
    list ? list.reduce(
        (prev, curr) => (prev ? `${prev}, ${curr}` : curr),
        '',
    ) : ''
);

export const listFromNewLineStrings = string => (
    string ? string.split(/[\r\n]+/).map(d => d.trim()) : []
);

export const listFromCommaStrings = (string, defaultValue = []) => (
    string ? string.split(',').map(d => d.trim()) : defaultValue
);

export const isNullOrUndefined = string => !string || string === '' || string === 'null' || string === 'undefined';
export const trimIfString = (obj) => {
    if (typeof obj === 'string' || obj instanceof String) {
        if (isEmptyHtml(obj)) {
            return undefined;
        }
        return obj.trim();
    }
    return obj;
};

export const firstLetterUp = string => (string ? string.charAt(0).toUpperCase() + string.slice(1) : null);

export const caseInsensitiveContains = (inputString, searchString) => inputString && inputString.toLowerCase().indexOf(searchString) > -1;

export const generateRandomString = (length = 8) => (+new Date() + Math.random().toString(36)).slice(-length);

export const trimDown = (str, maxLength) => (str.length > maxLength ? `${str.slice(0, maxLength)}...` : str);
